(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hero__video-wrapper').forEach((wrapper) => {
    const video = wrapper.querySelector('video');
    const button = wrapper.querySelector('.hero__video-play');

    if (!video || !button) return;

    const updateButton = () => {
      button.hidden = !video.paused;
    };

    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    button.addEventListener('click', () => {
      video.play().catch(() => {});
    });

    window.setTimeout(updateButton, 750);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
